import React from 'react';
import { motion } from 'framer-motion';
import { ScissorsIcon } from 'lucide-react';
import { Divider } from './ui/Divider';
const cuts = [{
  src: 'https://cdn.magicpatterns.com/uploads/nuHrrv392TZ4RFJQkdY9ho/b01.png',
  alt: 'Trenzas con fade',
  label: 'Trenzas + Fade'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5p86RdE7tDRXJ6RAod5mn8/b02.png',
  alt: 'Corte clásico con fade',
  label: 'Clásico Clean'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cjxvyjEMerZbJsXMcDwSTb/b03.png',
  alt: 'Diseño personalizado',
  label: 'Diseño Custom'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rwzrLvNYjsnqcEWJp5D5e6/b04.png',
  alt: 'Padre e hijo con color',
  label: 'Color + Fade'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3iPxYiDhmXBaBcPVaS6EaS/b05.png',
  alt: 'Fade perfecto',
  label: 'Fade Perfecto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/a4kQ5i7wFn3U5xJY9arD93/b06.png',
  alt: 'Afeitado con navaja',
  label: 'Afeitado Clásico'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gGNJhHvwQwfTkRpzao73bC/b07.png',
  alt: 'Mi primer corte - Padre e hijo',
  label: 'Mi Primer Corte'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1kMVfYtUDNkRnJWM3qJ2aP/b08.png',
  alt: 'Clientes satisfechos',
  label: 'Estilo & Confianza'
}];
// Duplicate for seamless loop
const allCuts = [...cuts, ...cuts];
export function GallerySection() {
  return <section id="galeria" className="bg-delux-alt py-20 border-y border-delux-gold/10 overflow-hidden" data-id="element-125">
      <style data-id="element-126">{`
        @keyframes scroll-gallery {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .gallery-track {
          animation: scroll-gallery 25s linear infinite;
        }
        .gallery-track:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-128">
          <ScissorsIcon className="w-10 h-10 text-delux-gold mx-auto mb-6" data-id="element-129" />
          <h2 className="font-heading text-3xl md:text-4xl text-delux-gold mb-4" data-id="element-130">
            Nuestros Cortes Hablan Por Sí Solos
          </h2>
          <p className="font-body text-lg text-delux-body max-w-2xl mx-auto" data-id="element-131">
            Cada corte es una obra de arte. Aquí está la prueba.
          </p>
        </motion.div>
      </div>

      {/* Horizontal Scrolling Carousel */}
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="relative" data-id="element-132">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-delux-alt to-transparent z-10 pointer-events-none" data-id="element-133" />
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-delux-alt to-transparent z-10 pointer-events-none" data-id="element-134" />

        <div className="gallery-track flex gap-5 md:gap-6 w-max" data-id="element-135">
          {allCuts.map((cut, index) => <div key={index} className="group relative flex-shrink-0 w-56 md:w-72 overflow-hidden rounded-xl border border-delux-gold/20" data-id="element-136">
              <div className="aspect-[3/4] overflow-hidden" data-id="element-137">
                <img src={cut.src} alt={cut.alt} className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-110" data-id="element-138" />
              </div>

              {/* Label overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end" data-id="element-139">
                <div className="p-4 w-full" data-id="element-140">
                  <p className="font-heading text-delux-gold text-lg tracking-wide" data-id="element-141">
                    {cut.label}
                  </p>
                </div>
              </div>

              {/* Gold corner accents */}
              <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-delux-gold/0 group-hover:border-delux-gold/60 transition-all duration-500 rounded-tl-xl" data-id="element-142" />
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-delux-gold/0 group-hover:border-delux-gold/60 transition-all duration-500 rounded-br-xl" data-id="element-143" />
            </div>)}
        </div>
      </motion.div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <Divider data-id="element-145" />
      </div>
    </section>;
}